import { render, staticRenderFns } from "./PriceField.vue?vue&type=template&id=7048e067"
import script from "./PriceField.vue?vue&type=script&lang=ts"
export * from "./PriceField.vue?vue&type=script&lang=ts"
import style0 from "./PriceField.vue?vue&type=style&index=0&id=7048e067&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports